import { produce } from 'immer';
import { findIndex, reject } from 'lodash/fp';
import {
    CREATE_GLOSSARY_CATEGORY_SUCCESS_GLOSSARY_CATEGORY_CREATED,
    CREATE_GLOSSARY_TERM_SUCCESS_GLOSSARY_TERM_CREATED,
    UPDATE_GLOSSARY_TERM_SUCCESS_GLOSSARY_TERM_UPDATED,
    DELETE_GLOSSARY_TERM_SUCCESS_GLOSSARY_TERM_DELETED
} from 'app/store/__generated__/events';
import { extractError } from 'app/lib/error';
import {
    LOAD_GLOSSARY,
    CREATE_CATEGORY,
    CREATE_GLOSSARY_TERM,
    UPDATE_GLOSSARY_TERM,
    RENAME_CATEGORY
} from './types.js';

export const INITIAL_STATE = {
    terms: [],
    categories: [],
    error: null
};

export const glossaryReducer = produce((draft, action) => {
    switch (action.type) {
        case LOAD_GLOSSARY.SUCCEEDED: {
            const { terms, categories } = action.payload;

            draft.terms = terms;
            draft.categories = Object.values(categories);
            break;
        }
        case CREATE_CATEGORY.STARTED:
        case CREATE_GLOSSARY_TERM.STARTED:
        case UPDATE_GLOSSARY_TERM.STARTED:
            draft.error = null;
            break;
        case CREATE_GLOSSARY_CATEGORY_SUCCESS_GLOSSARY_CATEGORY_CREATED: {
            const { name } = action.payload;

            draft.categories.push(name);
            break;
        }
        case CREATE_CATEGORY.FAILED:
        case RENAME_CATEGORY.FAILED:
        case CREATE_GLOSSARY_TERM.FAILED:
        case UPDATE_GLOSSARY_TERM.FAILED:
            draft.error = extractError(action.payload);
            break;
        case CREATE_GLOSSARY_TERM_SUCCESS_GLOSSARY_TERM_CREATED: {
            draft.terms.push({ ...action.payload });
            break;
        }
        case UPDATE_GLOSSARY_TERM_SUCCESS_GLOSSARY_TERM_UPDATED: {
            const { categoryName, name, description } = action.payload;
            const index = findIndex({ name }, draft.terms);

            draft.terms[index] = { categoryName, name, description };
            break;
        }
        case DELETE_GLOSSARY_TERM_SUCCESS_GLOSSARY_TERM_DELETED: {
            const { name } = action.payload;

            draft.terms = reject({ name }, draft.terms);
            break;
        }
        default:
    }
}, INITIAL_STATE);
